export enum EditorModeType {
  DEFAULT_MODE = 'DEFAULT_MODE',
  FRAGMENT_ATOM_MODE = 'FRAGMENT_ATOM_MODE',
  FRAGMENT_BOND_MODE = 'FRAGMENT_BOND_MODE',
  SELECT_MODE = 'SELECT_MODE',
  ROTATE_MODE = 'ROTATE_MODE',
  MOVE_MODE = 'MOVE_MODE',
  REMOVE_MODE = 'REMOVE_MODE',
  INCREASE_ATOM_CHARGE_MODE = 'INCREASE_ATOM_CHARGE_MODE',
  DECREASE_ATOM_CHARGE_MODE = 'DECREASE_ATOM_CHARGE_MODE',
  TOGGLE_BOND_DASHED_MODE = 'TOGGLE_BOND_DASHED_MODE',
  TOGGLE_BOND_WEDGED_MODE = 'TOGGLE_BOND_WEDGED_MODE',
}

export type EditorMode = {
  type: EditorModeType;
  data?: any;
};
